import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, Grid, IconButton, Paper } from '@mui/material';
import { Layout, Loading, UserNavbar, Input } from '../../../../../../components';
import * as UserActions from '../../../../../../core/users/action';
import VendorsList from './VendorsList';

const inputStyles = {
  // backgroundColor: '#fffdfd98',
  borderRadius: 50,
  width: '100vw',
  height: 95,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EE7B57',
};

export default function SearchVendors() {
  const dispatch = useDispatch();
  const { loading, usersVendorList, vendorUsersFilteredList } = useSelector((store) => store.users);
  const [inputSearch, setInputSearch] = useState('');

  const onSearch = (e) => {
    setInputSearch(e.target.value);
    dispatch(UserActions.onSearchVendorUsers(e.target.value));
  };

  const getVendorUserList = () =>
    vendorUsersFilteredList.length > 0 || inputSearch.trim() !== ''
      ? vendorUsersFilteredList
      : usersVendorList;

  useEffect(() => {
    dispatch(UserActions.onSearchVendorUsers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(UserActions.getVendorUsers());
  }, [dispatch]);

  return (
    <Layout>
      <UserNavbar />
      {loading && <Loading />}
      <Grid container justifyContent="center" marginTop={10}>
        <Grid item xs={9} marginBottom={3} style={inputStyles}>
          <Typography variant="h3" color="#EE7B57" fontWeight="bold" marginTop={4}>
            Vendors
          </Typography>
        </Grid>
        <Grid item xs={9} style={inputStyles}>
          <Input
            type="text"
            value={inputSearch}
            style={{ width: '65vw' }}
            placeholder="Search for the Vendor you want..."
            onChange={onSearch}
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="center">
        <Grid xs={9}>
          <VendorsList usersVendorList={getVendorUserList()} />
        </Grid>
      </Grid>
    </Layout>
  );
}
